import { ENV, Environment } from '@backoffice-frontend/environment'
import {
  confirmResetPassword as amplifyConfirmResetPassword,
  confirmSignIn as amplifyConfirmSignIn,
  fetchAuthSession as amplifyFetchAuthSession,
  fetchMFAPreference as amplifyFetchMFAPreference,
  getCurrentUser as amplifyGetCurrentUser,
  resetPassword as amplifyResetPassword,
  signIn as amplifySignIn,
  signOut as amplifySignOut,
  updatePassword as amplifyUpdatePassword,
} from 'aws-amplify/auth'
import { Hub as amplifyHub } from 'aws-amplify/utils'
import {
  confirmResetPassword as mockConfirmResetPassword,
  confirmSignIn as mockConfirmSignIn,
  fetchAuthSession as mockFetchAuthSession,
  fetchMFAPreference as mockFetchMFAPreference,
  getCurrentUser as mockGetCurrentUser,
  Hub as mockHub,
  resetPassword as mockResetPassword,
  signIn as mockSignIn,
  signOut as mockSignOut,
  updatePassword as mockUpdatePassword,
} from './amplifyMock'

const useMock = ENV === Environment.local || ENV === Environment.test

export const signIn = useMock ? mockSignIn : amplifySignIn

const customSignOut: typeof amplifySignOut = async options => {
  try {
    await amplifySignOut(options)
  } catch (_error) {
    const error = _error as AmplifyError
    if (error.name === 'InvalidRedirectException') {
      // We expect this error because we don't have a sign-out URL configured.
      // The `signOut` function already revoked the token and cleared the session,
      // so we can safely ignore this error.
      return
    }
    throw error
  }
}

export const signOut = useMock ? mockSignOut : customSignOut

export const confirmSignIn = useMock ? mockConfirmSignIn : amplifyConfirmSignIn

export const resetPassword = useMock ? mockResetPassword : amplifyResetPassword

export const fetchMFAPreference = useMock
  ? mockFetchMFAPreference
  : amplifyFetchMFAPreference

export const confirmResetPassword = useMock
  ? mockConfirmResetPassword
  : amplifyConfirmResetPassword

export const updatePassword = useMock
  ? mockUpdatePassword
  : amplifyUpdatePassword

export const fetchAuthSession = useMock
  ? mockFetchAuthSession
  : amplifyFetchAuthSession

export const getCurrentUser = useMock
  ? mockGetCurrentUser
  : amplifyGetCurrentUser

export const Hub: typeof amplifyHub = useMock ? mockHub : amplifyHub

export type AmplifyError = {
  name: string
  message: string
}
